var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-field',{staticClass:"mb-3"},[_vm._v(" "+_vm._s(_vm.$t('section.personal_data__hint'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }